import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import TransactionList from './TransactionList';
import PhotosGrid from './PhotosGrid';
import DeliveryDetails from './DeliveryDetails';
import NotesTab from './NotesTab';
import CommunicationTab from './CommunicationTab';
import EventsTab from './EventsTab';
import DocsTab from './DocsTab';
import BACTestsTab from './BACTestsTab';

interface Props {
  reservationInfo: any;
  openAddTransactionModal: ()=>void;
  openRefundModal: (refundDetails)=>void;
  width?: number;
}

export const ReservationExtensionPanel = ({reservationInfo, openAddTransactionModal, openRefundModal, width}:Props) => {
  const reservationId = reservationInfo?.id;

  const [activeTab, setActiveTab] = useState(2);

  const renderTab = (index, title, icon) => {
    const isActive = activeTab === index;
    return (
      <TouchableOpacity
        style={[styles.tabItem, isActive && styles.activeTab]}
        onPress={() => handlePress(index)}
        key={index}
      >
        <FontAwesome5 name={icon} size={22} color={isActive ? '#009999' : '#666'} style={{marginBottom:4}}/>
        <Text style={[styles.tabText, isActive && styles.activeTabText]}>{title}</Text>
      </TouchableOpacity>
    );
  };

  const handlePress = (index) => {
    setActiveTab(index);
  };

  const renderTabContent = () => {
    return (
      <View style={styles.tabContent}>
        {activeTab === 0 && (
          <NotesTab reservationInfo={reservationInfo}/>
        )}
        {activeTab === 1 && (
          <EventsTab reservationInfo={reservationInfo}/>
        )}
        {activeTab === 2 && (
          <TransactionList 
            reservationId={reservationId} 
            openAddTransactionModal={openAddTransactionModal}
            openRefundModal={openRefundModal}
          />
        )}
        {activeTab === 3 && (
          <CommunicationTab reservationInfo={reservationInfo}/>
        )}
        {activeTab === 4 && (
          <PhotosGrid reservationInfo={reservationInfo}/>
        )}
        {activeTab === 5 && (
          <DeliveryDetails reservationInfo={reservationInfo}/>
        )}
        {activeTab === 6 && (
          <DocsTab reservationInfo={reservationInfo}/>
        )}
        {activeTab === 7 && reservationInfo?.pricing_system === true && (
          <BACTestsTab reservationInfo={reservationInfo}/>
        )}
        {activeTab === 8 && (
          <View>
            <Text>Content for Extras</Text>
          </View>
        )}

      </View>
    );
  };

  return (
    <View style={[styles.container, {width:width || null}]}>
      <ScrollView 
        horizontal 
        showsHorizontalScrollIndicator={false}
        style={styles.tabBarContainer}
        contentContainerStyle={styles.tabBar}
      >
        {renderTab(0, 'Notes', 'sticky-note')}
        {renderTab(1, 'Events', 'calendar-check')}
        {renderTab(2, 'Transactions', 'money-bill-alt')}
        {renderTab(3, 'Comms', 'comment-dots')}
        {renderTab(4, 'Photos', 'images')}
        {renderTab(5, 'Delivery', 'truck')}
        {renderTab(6, 'Drivers', 'id-card')}
        {reservationInfo?.pricing_system === true && renderTab(7, 'BAC Tests', 'vial')}
        {renderTab(8, 'Extras', 'bookmark')}
      </ScrollView>
      <View style={styles.tabContent}>
        {renderTabContent()}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: '#cccccc',
    borderWidth: 1,
    paddingHorizontal:16,
    paddingTop:6,
    paddingBottom:12,
    marginBottom: 10,
  },
  tabBarContainer: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
    maxHeight: 60,
  },
  tabBar: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 2,
  },
  tabItem: {
    paddingHorizontal: 8,
    paddingTop: 10,
    paddingBottom: 8,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
    alignItems:'center',
    minWidth: 80,
  },
  tabText: {
    fontSize: 13,
    letterSpacing: 0.5,
    color: '#666',
  },
  activeTab: {
    borderBottomColor: '#009999',
  },
  activeTabText: {
    color: '#000',
    fontWeight: '500',
  },
  tabContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 400,
  },
});